import packageInfo from '../../../package.json';

import { ISecurableTree } from '../../services/UsersService';
import { paths } from '../../routes/Root/paths';

const version = packageInfo.version;
const root = '2a816185-af3d-46ae-9a94-65d3109b0408';

const securableTree: ISecurableTree[] = [
  {
    id: root,
    parentId: '20b3bb0a-6226-4cc7-9bcc-c9cb5c458f47',
    type: 'application',
    systemName: 'frontend',
    friendlyName: 'Фронтенд',
    clientVersion: version
  },
  {
    id: 'b39d78c0-ec94-4ddf-8bc6-ad9cb738e3a6',
    parentId: root,
    type: 'page',
    systemName: paths.map.root,
    friendlyName: 'Карта'
  },
  {
    id: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    parentId: 'b39d78c0-ec94-4ddf-8bc6-ad9cb738e3a6',
    type: 'page',
    systemName: paths.map.office.root,
    friendlyName: 'Место: Просмотр'
  },
  {
    id: '3bb26d38-127b-42b2-9b61-ade0b3b3e8a5',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'input',
    systemName: 'officeSwitchInfrastructure',
    friendlyName: 'Место: переключатель "Инфрасруктура"'
  },
  {
    id: '6790141d-9bff-419f-a99f-72a1b01811ba',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.create,
    friendlyName: 'Место: Добавить'
  },
  {
    id: '101950a3-058d-43f8-9b41-e45990f8432b',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.edit(),
    friendlyName: 'Место: Изменить'
  },
  {
    id: '320fa6c3-4c74-4715-bf0f-674a986734aa',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.plan.create,
    friendlyName: 'План: Добавить'
  },
  {
    id: 'fde2e668-6d3c-4565-84b8-3b8645f1f37b',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.plan.edit(),
    friendlyName: 'План: Изменить'
  },
  {
    id: 'f0843502-d986-441d-91fc-25043d077c33',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.users.root,
    friendlyName: 'Сотрудники: Список'
  },
  {
    id: '8b41d800-963e-4eb4-bb8b-b1a9eeb94227',
    parentId: 'f0843502-d986-441d-91fc-25043d077c33',
    type: 'page',
    systemName: paths.map.office.users.show(),
    friendlyName: 'Сотрудники: Просмотр'
  },
  {
    id: '54ebc6ae-b806-45c6-8c9c-b905a97eb306',
    parentId: 'f0843502-d986-441d-91fc-25043d077c33',
    type: 'page',
    systemName: paths.map.office.users.edit(),
    friendlyName: 'Сотрудники: Изменить'
  },
  {
    id: '394162d8-ec3b-431e-860e-33d18d1fdfc5',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'input',
    systemName: 'officeSwitchAreas',
    friendlyName: 'Место: переключатель "Зоны"'
  },
  {
    id: '4467bc4e-1717-4258-a12a-a045874d24e4',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.areas.root,
    friendlyName: 'Зоны: Список'
  },
  {
    id: '5f55affd-4184-41f8-bb67-0b87e3ff1b97',
    parentId: '4467bc4e-1717-4258-a12a-a045874d24e4',
    type: 'page',
    systemName: paths.map.office.areas.show(),
    friendlyName: 'Зоны: Просмотр'
  },
  {
    id: '9ea62306-bcfc-4d57-9168-5496f3045bac',
    parentId: '4467bc4e-1717-4258-a12a-a045874d24e4',
    type: 'page',
    systemName: paths.map.office.areas.create,
    friendlyName: 'Зоны: Добавить'
  },
  {
    id: '76382a0e-943d-4b6d-b3b3-d1cf25294de6',
    parentId: '4467bc4e-1717-4258-a12a-a045874d24e4',
    type: 'page',
    systemName: paths.map.office.areas.edit(),
    friendlyName: 'Зоны: Изменить'
  },
  {
    id: '96e901ae-d0af-403a-b14c-ce739243a349',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.infrastructure.root,
    friendlyName: 'Инфраструктура: Список'
  },
  {
    id: '87b9337b-9b40-4ed7-a81a-391bf2401a80',
    parentId: '96e901ae-d0af-403a-b14c-ce739243a349',
    type: 'page',
    systemName: paths.map.office.infrastructure.show(),
    friendlyName: 'Инфраструктура: Просмотр'
  },
  {
    id: 'b83be04b-2636-4b98-82ca-8b4c3f6f46fc',
    parentId: '96e901ae-d0af-403a-b14c-ce739243a349',
    type: 'page',
    systemName: paths.map.office.infrastructure.create,
    friendlyName: 'Инфраструктура: Добавление'
  },
  {
    id: 'a60eb725-8193-42dc-bfee-134c88fe271b',
    parentId: '96e901ae-d0af-403a-b14c-ce739243a349',
    type: 'page',
    systemName: paths.map.office.infrastructure.edit(),
    friendlyName: 'Инфраструктура: Изменение'
  },
  {
    id: 'c57c5cce-eeae-4685-b7fb-fa2e0e055a72',
    parentId: '0dc5c189-1947-4c85-a699-a06ae64fbb40',
    type: 'page',
    systemName: paths.map.office.cameras.root,
    friendlyName: 'Камеры: Список'
  },
  {
    id: 'c603c819-f8a2-4c4a-ab40-975f1854794a',
    parentId: 'c57c5cce-eeae-4685-b7fb-fa2e0e055a72',
    type: 'page',
    systemName: paths.map.office.cameras.show(),
    friendlyName: 'Камеры: Просмотр'
  },
  {
    id: 'cc30b1d0-86ad-4e47-88af-f3108249af91',
    parentId: 'c57c5cce-eeae-4685-b7fb-fa2e0e055a72',
    type: 'page',
    systemName: paths.map.office.cameras.create,
    friendlyName: 'Камеры: Добавление'
  },
  {
    id: '16337146-ebba-4058-b9f5-5ab975c77af3',
    parentId: 'c57c5cce-eeae-4685-b7fb-fa2e0e055a72',
    type: 'page',
    systemName: paths.map.office.cameras.edit(),
    friendlyName: 'Камеры: Изменение'
  },
  {
    id: 'c94e1c86-0196-4b5a-8725-20b44f58c501',
    parentId: root,
    type: 'page',
    systemName: paths.staff.root,
    friendlyName: 'Персонал'
  },
  {
    id: 'e31fed38-39d5-4a0f-bc31-ab11359a7ba1',
    parentId: 'c94e1c86-0196-4b5a-8725-20b44f58c501',
    type: 'page',
    systemName: paths.staff.users.root,
    friendlyName: 'Сотрудники'
  },
  {
    id: 'c8d4164b-9c8e-4172-aa91-153d9fcc4221',
    parentId: 'e31fed38-39d5-4a0f-bc31-ab11359a7ba1',
    type: 'page',
    systemName: paths.staff.users.create,
    friendlyName: 'Сотрудники: добавление'
  },
  {
    id: '00b3e603-fc37-4488-8ca7-e669164e265f',
    parentId: 'e31fed38-39d5-4a0f-bc31-ab11359a7ba1',
    type: 'page',
    systemName: paths.staff.users.edit(),
    friendlyName: 'Сотрудники: изменение'
  },
  {
    id: 'e3b37b2c-1a43-4f9e-b37b-c7980dcfa390',
    parentId: 'c94e1c86-0196-4b5a-8725-20b44f58c501',
    type: 'page',
    systemName: paths.staff.departaments.root,
    friendlyName: 'Структурные подразделения'
  },
  {
    id: 'e173edef-34fe-4a68-91a8-656baeeaf64b',
    parentId: 'e3b37b2c-1a43-4f9e-b37b-c7980dcfa390',
    type: 'page',
    systemName: paths.staff.departaments.create,
    friendlyName: 'Структурные подразделения: добавление'
  },
  {
    id: '566a5e7e-01c8-4513-8796-5c1b7f9e19da',
    parentId: 'e3b37b2c-1a43-4f9e-b37b-c7980dcfa390',
    type: 'page',
    systemName: paths.staff.departaments.edit(),
    friendlyName: 'Структурные подразделения: изменение'
  },
  {
    id: 'c5aac0a7-e91a-4fd2-8a4a-cb39f38e5fcf',
    parentId: 'e3b37b2c-1a43-4f9e-b37b-c7980dcfa390',
    type: 'page',
    systemName: paths.staff.departaments.copy(),
    friendlyName: 'Структурные подразделения: копирование'
  },
  {
    id: '1a120c2c-b46c-4e57-ab22-3193a949e8c3',
    parentId: root,
    type: 'page',
    systemName: paths.equipment.root,
    friendlyName: 'Оборудование'
  },
  {
    id: 'a368a169-bc91-4027-807f-606e91d274cd',
    parentId: '1a120c2c-b46c-4e57-ab22-3193a949e8c3',
    type: 'page',
    systemName: paths.equipment.beacons.root,
    friendlyName: 'Инфраструктура'
  },
  {
    id: 'bc392241-9631-465b-b643-58e2cc3fca21',
    parentId: '1a120c2c-b46c-4e57-ab22-3193a949e8c3',
    type: 'page',
    systemName: paths.equipment.cameras.root,
    friendlyName: 'Камеры'
  },
  {
    id: '53ee0ba1-7d87-4483-a1b4-50716da8d853',
    parentId: '1a120c2c-b46c-4e57-ab22-3193a949e8c3',
    type: 'page',
    systemName: paths.equipment.protections.root,
    friendlyName: 'Реестр СИЗ'
  },
  {
    id: '6b745e07-dcfa-43f3-8d1b-1b88d912622f',
    parentId: '53ee0ba1-7d87-4483-a1b4-50716da8d853',
    type: 'page',
    systemName: paths.equipment.protections.create,
    friendlyName: 'Реестр СИЗ: добавление'
  },
  {
    id: 'ae4bb5be-c99a-461d-bcfd-4dfef044862f',
    parentId: '53ee0ba1-7d87-4483-a1b4-50716da8d853',
    type: 'page',
    systemName: paths.equipment.protections.edit(),
    friendlyName: 'Реестр СИЗ: изменение'
  },
  {
    id: '2cf56803-d908-4728-b5aa-f3fd230e485e',
    parentId: '53ee0ba1-7d87-4483-a1b4-50716da8d853',
    type: 'page',
    systemName: paths.equipment.protections.copy(),
    friendlyName: 'Реестр СИЗ: копирование'
  },
  {
    id: '75424e4e-0284-4ca8-afab-26d964501eeb',
    parentId: '1a120c2c-b46c-4e57-ab22-3193a949e8c3',
    type: 'page',
    systemName: paths.equipment.devices.root,
    friendlyName: 'Носимые устройства'
  },
  {
    id: '942d7082-1103-47ab-9635-3e101a988007',
    parentId: '75424e4e-0284-4ca8-afab-26d964501eeb',
    type: 'page',
    systemName: paths.equipment.devices.create,
    friendlyName: 'Носимые устройства: добавление'
  },
  {
    id: 'ebddaf01-bb52-4322-a5ea-dc00bd73cbfc',
    parentId: '75424e4e-0284-4ca8-afab-26d964501eeb',
    type: 'page',
    systemName: paths.equipment.devices.edit(),
    friendlyName: 'Носимые устройства: изменение'
  },
  {
    id: '1809bb70-5f3f-470f-8c02-98add6c87fd3',
    parentId: '75424e4e-0284-4ca8-afab-26d964501eeb',
    type: 'page',
    systemName: paths.equipment.devices.copy(),
    friendlyName: 'Носимые устройства: копирование'
  },
  {
    id: '3c200fbf-b6a7-4897-ba15-e971c56fb022',
    parentId: root,
    type: 'page',
    systemName: paths.reports.root,
    friendlyName: 'Отчёты'
  },
  {
    id: '22917d31-07c5-4687-9df3-de62146bd413',
    parentId: root,
    type: 'page',
    systemName: paths.notifications,
    friendlyName: 'Уведомления'
  },
  {
    id: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    parentId: root,
    type: 'page',
    systemName: paths.settings.root,
    friendlyName: 'Настройки'
  },
  {
    id: '28bbda63-b762-4a35-8bb5-c329594d6934',
    parentId: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    type: 'page',
    systemName: paths.settings.notifications.root,
    friendlyName: 'Настройки: уведомления - просмотр'
  },
  {
    id: 'c74e8cfe-0339-4ee3-a7bd-29bcee6ce429',
    parentId: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    type: 'page',
    systemName: paths.settings.notifications.create,
    friendlyName: 'Настройки: уведомления - добавление'
  },
  {
    id: 'c2208671-1de6-4c81-a73b-10d5f754e31a',
    parentId: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    type: 'page',
    systemName: paths.settings.notifications.edit(),
    friendlyName: 'Настройки: уведомления - изменение'
  },
  {
    id: '4d02eed1-f060-45a6-8fd7-dcf10a4a1233',
    parentId: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    type: 'page',
    systemName: paths.settings.protectionTypes.root,
    friendlyName: 'Настройки: типы СИЗ - просмотр'
  },
  {
    id: 'fa8e519f-ad5a-4531-b055-4e1381142d65',
    parentId: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    type: 'page',
    systemName: paths.settings.protectionTypes.create,
    friendlyName: 'Настройки: типы СИЗ - добавление'
  },
  {
    id: '4a33aed2-8134-4a79-b2d3-c56d506b06d5',
    parentId: '8d15c93a-e534-4f1c-80bd-837550c4395a',
    type: 'page',
    systemName: paths.settings.protectionTypes.edit(),
    friendlyName: 'Настройки: типы СИЗ - изменение'
  }
];

export default { version, root, securableTree };
